import { WagtailNavigation } from '@/types';
import { removeBaseUrl } from '@utils/url';
import Link from 'next/link';
import { ComponentProps } from 'react';

type Props = {
  menuItem: WagtailNavigation;
  index: number;
  onClick: ComponentProps<'button'>['onClick'];
  activeIndex: number | null;
};

function MobileSubNavigation(props: Props) {
  const { menuItem, index, onClick, activeIndex } = props;
  return (
    <>
      <button
        className='nav__sub-menu-trigger'
        aria-expanded={index === activeIndex}
        aria-controls={`sub-menu-${index}`}
        onClick={onClick}
      >
        {menuItem.nav_title ? menuItem.nav_title : menuItem.title}
      </button>
      <ul role='list' className='nav__sub-menu' id={`sub-menu-${index}`}>
        <li className='nav__sub-menu-item'>
          <Link href={removeBaseUrl(menuItem.full_url)} className='nav__link sub-menu__link overview'>
            Zur Übersicht
          </Link>
        </li>
        {menuItem.children.map((child, i) => (
          <li className='nav__sub-menu-item' key={`${i}${menuItem.title}`}>
            <Link href={removeBaseUrl(child.full_url)} className='nav__link sub-menu__link'>
              {child.nav_title ? child.nav_title : child.title}
            </Link>
          </li>
        ))}
      </ul>
    </>
  );
}

export default MobileSubNavigation;
